export default __webpack_public_path__ + "static/media/34.e6ffd4d7.jpeg";